export default __webpack_public_path__ + "static/media/shuratrust-project.dbd69c8b.jpeg";